import React, { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function ReminderDialog({ open, onOpenChange, pets, petId, onSaved }) {
  const [f, setF] = useState({ pet_id: petId || "", title: "", kind: "vaccine", due_date: "", notes: "" });
  const onlyPet = pets?.length === 1 ? pets[0].id : "";
  if (!f.pet_id && onlyPet) setF({ ...f, pet_id: onlyPet });
  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/reminders", { ...f, pet_id: f.pet_id || petId || pets?.[0]?.id });
      toast.success("Reminder added");
      onSaved?.();
      onOpenChange(false);
      setF({ ...f, title: "", due_date: "", notes: "" });
    } catch (err) { toast.error(errMsg(err)); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl bg-[#FAF7F2]">
        <DialogHeader><DialogTitle className="font-heading text-2xl">Add reminder</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4" data-testid="reminder-form">
          {!petId && pets && (
            <div><label className="pl-label">Pet</label>
              <select required className="pl-input" data-testid="reminder-pet-select" value={f.pet_id} onChange={set("pet_id")}>
                <option value="">Choose a pet</option>{pets.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select></div>
          )}
          <div><label className="pl-label">What's due?</label><input required className="pl-input" placeholder="e.g. Rabies booster, vet checkup" data-testid="reminder-title-input" value={f.title} onChange={set("title")} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="pl-label">Type</label>
              <select className="pl-input" data-testid="reminder-kind-select" value={f.kind} onChange={set("kind")}>
                <option value="vaccine">Vaccine</option><option value="preventive">Preventive</option><option value="vet_visit">Vet visit</option><option value="other">Other</option>
              </select></div>
            <div><label className="pl-label">Due date</label><input required type="date" className="pl-input" data-testid="reminder-due-input" value={f.due_date} onChange={set("due_date")} /></div>
          </div>
          <div><label className="pl-label">Notes</label><input className="pl-input" data-testid="reminder-notes-input" value={f.notes} onChange={set("notes")} /></div>
          <button className="pl-btn-primary w-full" data-testid="reminder-save-btn">Save reminder</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function ReminderRow({ r, pet, onToggle, onDelete }) {
  const days = Math.round((new Date(`${r.due_date}T12:00:00`) - new Date()) / 864e5);
  const tone = r.done ? "text-slate-400" : days < 0 ? "text-[#C2410C]" : days <= 7 ? "text-[#B45309]" : "text-slate-500";
  return (
    <div className="pl-card p-3 flex items-center gap-3" data-testid={`reminder-${r.id}`}>
      <input type="checkbox" checked={r.done} onChange={() => onToggle(r)} data-testid={`reminder-${r.id}-done`} className="h-6 w-6 accent-[#10B981]" />
      <div className="flex-1 min-w-0">
        <p className={`font-semibold ${r.done ? "line-through text-slate-400" : ""}`}>{pet ? `${pet.name}: ` : ""}{r.title}</p>
        <p className={`text-xs font-semibold ${tone}`}>{r.done ? "Done" : days < 0 ? `Overdue by ${-days} day(s)` : days === 0 ? "Due today" : `Due in ${days} day(s)`} · {r.due_date}{r.source === "vet_record" ? " · from vet record" : ""}</p>
      </div>
      <button onClick={() => onDelete(r)} data-testid={`reminder-${r.id}-delete`} className="text-xs text-slate-400 font-semibold px-2">Delete</button>
    </div>
  );
}

export async function toggleReminder(r) {
  await api.put(`/reminders/${r.id}`, { ...r, done: !r.done });
}
